export const HTTP_200 = 200 // OK
export const HTTP_400 = 400 // HTTP内部的类型转换等错误，输入了非预期内的值
export const HTTP_403 = 403 // 身份错误
export const HTTP_404 = 404 // 找不到资源
export const HTTP_500 = 500 // 服务器错误 / 服务器内部致命错误
export const HTTP_503 = 503 // 服务器不可用 / 服务器忙, 有限流的API会返回503

export const CODE_OK = 0
export const CODE_COMMON_FAIL = -1
export const CODE_ARG_NOT_VALID = 3001
export const CODE_PARAM_CONVERT_ERR = 3002

export const CODE_AUTH_FAIL = 10000
export const CODE_SEND_SMS_FAILED = 10001
export const CODE_VERIFY_CODE_FAILED = 10002
export const CODE_LOGIN_USER_NOT_EXIST = 10009 // 还未注册，引导去注册页
export const CODE_REGISTER_USER_EXIST = 10010 // 用户已注册，引导去登录页
export const CODE_REGISTER_WRONG_PHONE_OR_PASSWD = 10011 // 手机号或密码错误
export const CODE_ALREADY_BOUND = 10012 // 微信已经绑定其他账号
export const CODE_PAY_WECHAT_NOT_BIND = 10050 // 支付时没有绑定微信
export const CODE_PAY_WECHAT_ALREAD_BOUND = 10052 // 微信绑定的是另一个账号
export const CODE_WECHAT_NIMIAPP_NOT_LOGIN = 10054
export const CODE_OBITUARY_NOT_EXIST = 11302 // 讣告不存在
export const CODE_WREATH_NOT_EXIST = 11304 // 花圈不存在
export const CODE_COUPLET_NOT_EXIST = 11305 // 挽联不存在
export const CODE_COUPON_ALREADY_RECEIVED = 10530 // 优惠券已经领取
export const CODE_MINIPROGRAM_NOT_LOGIN = 10402 // 小程序未登录，引导去登录页
// life
export const CODE_LIFE_NOT_EXIST = 10100 // life不存在
export const CODE_NAME_DUPLICATE = 10101 // 姓名重复
export const CODE_LIFE_NOT_OPEN = 10123 //纪念设置为不开放
export const CODE_LIFE_BANNED = 10124 // 纪念被封禁
export const CODE_LIFE_BLOCKED = 10125 //  该用户被当前纪念封禁

// register
export const CODE_NOT_REGISTER = 10030 // 用户未注册

// member
export const CODE_MEMBER_STORAGE_NOT_ENOUGH = 10500
export const CODE_MEMBER_CREATOR_STORAGE_NOT_ENOUGH = 10501
export const CODE_STORAGE_NOT_ENOUGH = 10502
export const CODE_CREATOR_STORAGE_NOT_EXIST = 10503
export const CODE_MEMBER_CAN_OPEN_SMS = 10506
export const CODE_EXCEED_MAX_PERIOD = 10507

// theme
export const CODE_MEMBER_ONLY_THEME = 10550

// 资源的限制
export const CODE_LIFE_LIMIT_EXCEEDED = 10504
export const CODE_MEMBER_LIFE_LIMIT_EXCEEDED = 10505

// gift
export const CODE_BALANCE_NOT_ENOUGH = 11102

// potrait
export const CODE_PORTRAIT_PAID = 10608
export const CODE_PORTRAIT_MORE_THAN_LIMIT = 10611
